import { Box, Menu, Stack, styled } from '@mui/material';
import { SelectInsideCell } from 'components/SelectMenu/types';
import { blue } from '../../themes/colors';

export const StyledBox = styled(Box) <SelectInsideCell>`
  max-width: 100%;
  border: ${({ inner, new: isNew }) => (inner ? '0' : isNew ? '1px solid #145DA0' : '1px solid #ccc')};
  border-radius: ${({ inner, new: isNew }) => (inner ? '0px' : isNew ? '4px' : '8px')};
  font-size: 1rem;
  height: ${({ inner, new: isNew }) => (inner ? '100%' : isNew ? '32px' : 'auto')};
  max-height: ${({ inner, new: isNew }) => (inner ? '100%' : isNew ? '32px' : '40px')};
  overflow: hidden;
  background-color: ${({ new: isNew }) => (isNew ? '#145DA0' : '#fff')}; 
  color: ${({ new: isNew }) => (isNew ? '#fff' : '#172B4D')};

  &:hover {
    cursor: pointer;
  }
`;

export const StyledMenuDropDown = styled(Menu)`
  max-height: 600px;
  & .MuiList-root {
    padding: 0;
  }

  & .MuiPaper-root {
    border-radius: 4px;
    margin-top: 8px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
  & .css-7s3bii-MuiStack-root{
    background-color: ${blue[400]};
  }
  
`;
export const StyledFirstSelectOption = styled(Stack) <SelectInsideCell>`
  justify-content: space-between;
  align-items: center;
  height: ${({ inner, new: isNew }) => (inner ? '100%' : isNew ? '32px' : '40px')};
  position: relative;
  padding: 8.5px 16px;
  font-weight: 600;
`;
